import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestGetWebToLeadDetails } from "../../Store/Template/action";
import { handleValidateCodevalue } from "../../Utility/constant";
import { requestHideLoader, requestShowLoader } from "../../Store/Global/action";
import { createRequestData, updateRequestData } from "../../Utility/apiHelper";
import BiztantuLoader from "../../Components/Loader";
import { StyledConfigurationContainer, StyledFlexStart, StyledLeadContainer, StyledSubHeader } from "../../Components/Styled";
import { Box, Button, Typography, Paper, Stack, Chip, IconButton, InputAdornment, Tooltip } from "@mui/material";
import TextFiledWithLabel from "../../Components/TextFieldWithLabel";
import AutoCompleteComponent from "../../Components/AutoCompleteComponenet";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import './template.css';

const WebToLead = () => {
  const internationalise = useSelector((state) => state?.internationalise?.currentHashMapData);
  const isLoading = useSelector((state) => state?.global?.isLoading);
  const webToLeadStoreData = useSelector((state) => state?.template?.webToLeadData) || {};

  const ownerlist = useSelector((state) => state?.owner?.ownerlist) || [];
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [webToLeadData, setWebToLeadData] = useState({
    id: null,
    token: "",
    formTitle: "",
    successMessage: "",
    redirectUrl: "",
    selectedOwner: null,
    defaultOwnerId: "",
    selectedSource: null,
    source: "",
  });
  const [tokenCopied,setTokenCopied] = useState(false)
  const [requiredError, setRequiredError] = useState({
    formTitle: false,
    selectedOwner: false,
  });

  useEffect(() => {
    dispatch(requestGetWebToLeadDetails());
  }, [dispatch]);
const formatJson = (data) => JSON.stringify(data || {}, null, 2);
  useEffect(() => {
    if (!webToLeadStoreData) return;
      const selectedOwner =
        ownerlist?.find((item) => item?.id === webToLeadStoreData?.defaultOwnerId) || null;


      setWebToLeadData((prev) => ({
        ...prev,
        id: webToLeadStoreData?.id || null,
        token: webToLeadStoreData?.token || "",
        endpoint: "https://api.biztantu.com/web-to-lead/public" || "",
        apiUsage: {
                method: "POST",
               requestHeaders: {
                    "Content-Type": "application/json",
                    "X-Web-To-Lead-Token": "<web-to-lead-token>"
                },
                payload: {
                    firstName: "<first-name>",
                    lastName: "<last-name>",
                    countryCode: "<country-code>",
                    mobile: "<mobile-number>",
                    email: "<email-address> (mandatory)",
                    query: "<message-or-query> (mandatory)"
                }
            } || {},
        selectedOwner,
        defaultOwnerId: webToLeadStoreData?.defaultOwnerId || "",
        }));
  }, [webToLeadStoreData, ownerlist]);

  const handleOnChange = (event) => {
    const { name, value } = event.target;

    setWebToLeadData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectAutocomplete = (event, value, type) => {
      setWebToLeadData((prev) => ({
        ...prev,
        [type]: value,
        defaultOwnerId: value?.id || "",
      }));
  };

  const validateWebToLead = () => {
    const errors = {
      selectedOwner: !webToLeadData?.selectedOwner,
    };

    setRequiredError(errors);

    return Object.values(errors).some(Boolean);
  };

  const handleSave = async () => {
    if (validateWebToLead()) {
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"),
        { variant: "error" }
      );
      return;
    }

    try {
      dispatch(requestShowLoader());

      const payload = {
        defaultOwnerId: webToLeadData?.defaultOwnerId,
      };

      const url = webToLeadData?.id
        ? `${process.env.REACT_APP_BASE_URL}web-to-lead/${webToLeadData?.id}`
        : `${process.env.REACT_APP_BASE_URL}web-to-lead`;

      const saveApi = webToLeadData?.id ? updateRequestData : createRequestData;
      const response = await saveApi(payload, url);

      if (response?.status === 200 || response?.status === 201) {
        enqueueSnackbar(
          handleValidateCodevalue(internationalise, 
            webToLeadData?.id ?
            "COMMON_UPDATED_SUCCESSFULLY":
            "COMMON_SAVED_SUCCESSFULLY"
        ),{ variant: "success" }
        );
        dispatch(requestGetWebToLeadDetails());
      }
    } catch (error) {
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"),
        { variant: "error" }
      );
    } finally {
      dispatch(requestHideLoader());
    }
  };

  const handleRegenerateToken = async () => {
    try {
      dispatch(requestShowLoader());

      const url = `${process.env.REACT_APP_BASE_URL}web-to-lead/regenerate-token`;
      const response = await createRequestData({}, url);

      if (response?.status === 200 || response?.status === 201) {
        dispatch(requestGetWebToLeadDetails());
      }
    } catch {
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"),
        { variant: "error" }
      );
    } finally {
      dispatch(requestHideLoader());
    }
  };
const copyToClipboard = async (text) => {
  try {
   if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
    setTokenCopied(true)
    setTimeout(() => {
            setTokenCopied(false);
        }, 2000);
  } catch (error) {
    // enqueueSnackbar("COPY_FAILED", { variant: "error" });
  }
};

  return (
    <BiztantuLoader isChildren open={isLoading}>
      <StyledLeadContainer>
        <StyledConfigurationContainer className="web-to-lead-heading">
          <Typography variant="h6">
            {handleValidateCodevalue(internationalise, "WEB_TO_LEAD_PAGE_TITLE")}
          </Typography>
        </StyledConfigurationContainer>
      </StyledLeadContainer>
      <Box className="hide-scrollbar globalBox web-to-lead-content">
        <StyledSubHeader className="web-to-lead-section-heading">
          {handleValidateCodevalue(internationalise, "WEB_TO_LEAD_DETAILS")}
        </StyledSubHeader>
        <StyledFlexStart className = "gap-40">
          <AutoCompleteComponent
            isOwner
            id = "webToLeadOwner"
            optionSet={ownerlist}
            value={webToLeadData?.selectedOwner || null}
            required
            error={webToLeadData?.selectedOwner ? false : requiredError?.selectedOwner}
            name="selectedOwner"
            placeholder={handleValidateCodevalue(internationalise, "TASK_SEARCH_OWNER")}
            label={handleValidateCodevalue(internationalise, "TASK_SEARCH_OWNER")}
            onChange={(event, value) =>
              handleSelectAutocomplete(event, value, "selectedOwner")
            }
          />

          <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_SAVE")}>
          <Button
            variant="outlined"
            className="biztantu-sec-btn web-to-lead-action-button"
            onClick={handleSave}
          >
            {handleValidateCodevalue(internationalise, "COMMON_SAVE")}
          </Button>
          </Tooltip>
        </StyledFlexStart>
        <StyledSubHeader className="web-to-lead-usage-heading">
            {handleValidateCodevalue(internationalise, "WEB_TO_LEAD_API_USAGE") || "API Usage"}
        </StyledSubHeader>

<Paper
  elevation={0}
  className="web-to-lead-usage-card"
>
    
        <StyledFlexStart className = "gap-40">
          <StyledFlexStart>
         <TextFiledWithLabel
            name="token"
            disabled
            value={webToLeadData?.token || ""}
            label={handleValidateCodevalue(internationalise, "WEB_TO_LEAD_TOKEN")}
            InputLabelProps={{ shrink: true }}
            className="web-to-lead-token"
            />
            {!tokenCopied ?
                  <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_COPY")}>
                    <IconButton
                     onClick={() => copyToClipboard(webToLeadData?.token || "")}
                    >
                    <ContentCopyIcon />
                    </IconButton>
                  </Tooltip>
                  :
                  <Box
                  className="web-to-lead-copied"
                >
                  <CheckIcon className="web-to-lead-copied-icon" />
                  {handleValidateCodevalue(internationalise, "COMMON_COPIED")}
                </Box>
                  }
            </StyledFlexStart>
            
          <Tooltip title={handleValidateCodevalue(internationalise, "REGEN_WEB_TO_LEAD_TOKEN")}>
            <Button
              variant="outlined"
              className="biztantu-sec-btn web-to-lead-action-button"
              onClick={handleRegenerateToken}
            >
              {handleValidateCodevalue(internationalise, "REGEN_WEB_TO_LEAD_TOKEN")}
            </Button>
            </Tooltip>
        </StyledFlexStart>
  <Stack spacing={2} pt = {2}>
 <StyledLeadContainer>
      
      <TextFiledWithLabel
        name="apiUrl"
        disabled
        value={webToLeadData?.endpoint || ""}
        label={handleValidateCodevalue(internationalise, "WEB_TO_LEAD_API_URL") || "API URL"}
        InputLabelProps={{ shrink: true }}
        className="web-to-lead-api-url"
        InputProps={{
                startAdornment: (
                <InputAdornment position="start" className="web-to-lead-api-method">
                    <Chip
                        label={webToLeadData?.apiUsage?.method || "POST"}
                        color="primary"
                        size="small"
                    />
                </InputAdornment>
                )
            }}
      />
    </StyledLeadContainer>

    <Box>
      <Typography variant="subtitle2" className="web-to-lead-subtitle">
        {handleValidateCodevalue(internationalise, "WEB_TO_LEAD_REQUEST_HEADERS") || "Request Headers"}
      </Typography>

      <Box
        component="pre"
        className = "jsonCodeBlock"
      >
        {formatJson(webToLeadData?.apiUsage?.requestHeaders)}
      </Box>
    </Box>

    <Box>
      <Typography variant="subtitle2" className="web-to-lead-subtitle">
        {handleValidateCodevalue(internationalise, "WEB_TO_LEAD_PAYLOAD")}
      </Typography>

      <Box
        component="pre"
        className = "jsonCodeBlock"
      >
        {formatJson(webToLeadData?.apiUsage?.payload)}
      </Box>
    </Box>
  </Stack>
</Paper>
      </Box>
    </BiztantuLoader>
  );
};

export default WebToLead;